import { Skeleton } from "@mui/material";

const AddOrEditAddressSkeleton = () => {
  return (
    <div>
      <div>
        {" "}
        <Skeleton variant="rectangular" height={400} />
      </div>
      <div style={{ marginTop: "20px" }}>
        <div className="row">
          <div className="col-md-12">
            <Skeleton variant="text" width="100%" height={40} />
          </div>
          <div className="col-md-12 mt-3">
            <Skeleton variant="text" width="100%" height={40} />
          </div>
          <div className="col-md-12 mt-3">
            <Skeleton variant="text" width="100%" height={40} />
          </div>
          <div className="col-md-12 mt-3">
            <Skeleton variant="text" width="100%" height={40} />
          </div>

          <div className="col-md-12 mt-2">
            <Skeleton variant="rectangular" height={48} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddOrEditAddressSkeleton;
